import { useState } from "react";
import { TextInput } from "../../../../components/ui/inputs";
import localization from "../../../../config/localization";
import { Button } from "../../../../components/ui/Button";
import { PhoneNumberInput } from "../../../../components/ui/inputs/PhoneNumberInput";
import { OtpModal } from "../../../../components/ui/modals";
import userService from "../../services/user.service";
import { toastService as toast } from "../../../../components/ui/toast/toast.service";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../store/hooks";
import { changeLoginModalState } from "../../../../reducers/appStateReducer";
import { Validations } from "../../../../models/constants/validations";

export function EmailAndMobileVerfification({
  userId,
  handleBackButton,
}: {
  userId: string;
  handleBackButton: () => void;
}) {
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");

  const [showEmailVerificationModal, setShowEmailVerificationModal] =
    useState(false);
  const [emailVerificationErrorMessage, setEmailVerificationErrorMessage] =
    useState("");

  const [emailErrorMessage, setEmailErrorMessage] = useState<string | null>(null);
  const [mobileErrorMessage, setMobileErrorMessage] = useState<string | null>(null);

  const [showMobileVerificationModal, setShowMobileVerificationModal] =
    useState(false);
  const [mobileVerificationErrorMessage, setMobileVerificationErrorMessage] =
    useState("");

  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [isMobileVerified, setIsMobileVerified] = useState(false);

  const [countryCode, setCountryCode] = useState("+91");

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleVerifyEmail = () => {
    if (validateEmail()) {
      handleSendEmailVerificationCode();
    }
  };

  const clearEmailErrorMessageOnFocus = () => {
    setEmailErrorMessage((prev) => (prev ? null : prev));
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);
    setEmailErrorMessage((prev) => (value ? null : prev));
  };

  const validateEmail = () => {
    setEmailErrorMessage(null);
    if (!email) {
      setEmailErrorMessage("email_error");
      return false;
    }

    if (!Validations.email.regex.test(email)) {
      setEmailErrorMessage("valid_email");
      return false;
    }

    return true;
  };

  const handleSendEmailVerificationCode = () => {
    userService.sendEmailVerificationCode(userId, email).then((response) => {
      if (response.isSuccess) {
        var message = localization.getString(response.message);
        toast.success(message);
        setTimeout(() => {
          setShowEmailVerificationModal(true);
        }, 1000);
      }
    });
  };

  const handleResendEmailVerificationCode = () => {
    userService.sendEmailVerificationCode(userId, email).then((response) => {
      if (response.isSuccess) {
        var message = localization.getString(response.message);
        toast.success(message);
        setEmailVerificationErrorMessage("");
      }
    });
  };

  const handleVerifyEmailVerificationCode = (otp: string) => {
    userService.verifyEmailVerificationCode(userId, otp).then((response) => {
      if (response.isSuccess) {
        setIsEmailVerified(true);
        setShowEmailVerificationModal(false);
        var message = localization.getString(response.message);
        toast.success(message);
        setTimeout(() => {
          if (isMobileVerified) {
            navigate("/");
            dispatch(changeLoginModalState(true));
          }
        }, 1000);
      }
    });
  };

  const handleVerifyMobile = () => {
    if (validateMobile()) {
      handleSendMobileVerificationCode();
    }
  };

  const clearMobileErrorMessageOnFocus = () => {
    setMobileErrorMessage((prev) => (prev ? null : prev));
  };

  const handleMobileChange = (value: string) => {
    setMobile(value);
    setMobileErrorMessage((prev) => (value ? null : prev));
  };

  const validateMobile = () => {
    setMobileErrorMessage(null);
    if (!mobile) {
      setMobileErrorMessage("enter_mobile");
      return false;
    }

    if (!Validations.mobile.regex.test(mobile)) {
      setMobileErrorMessage("mobile_validation_error");
      return false;
    }
    return true;
  };

  const handleSendMobileVerificationCode = () => {
    userService
      .sendMobileVerificationCode(userId, mobile, countryCode)
      .then((response) => {
        if (response.isSuccess) {
          var message = localization.getString(response.message);
          toast.success(message);
          setShowMobileVerificationModal(true);
        }
      });
  };

  const handleResendMobileVerificationCode = () => {
    userService
      .sendMobileVerificationCode(userId, mobile, countryCode)
      .then((response) => {
        if (response.isSuccess) {
          var message = localization.getString(response.message);
          toast.success(message);
          setMobileVerificationErrorMessage("");
        }
      });
  };

  const handleVerifyMobileVerificationCode = (otp: string) => {
    userService.verfiyMobileVerificationCode(userId, otp).then((response) => {
      if (response.isSuccess) {
        setIsMobileVerified(true);
        setShowMobileVerificationModal(false);
        setTimeout(() => {
          if (isEmailVerified) {
            navigate("/");
            dispatch(changeLoginModalState(true));
          }
        }, 1000);
      }
    });
  };

  const handleCloseEmailVerificationModal = () => {
    setShowEmailVerificationModal(false);
    setEmailVerificationErrorMessage("");
  };

  const handleCloseMobileVerificationModal = () => {
    setShowMobileVerificationModal(false);
    setMobileVerificationErrorMessage("");
  };

  return (
    <div>
      <TextInput
        label={localization.email}
        placeholder={localization.enter_email}
        value={email}
        inputClassName="px-4 py-2 h-12"
        iconText={!isEmailVerified ? localization.verify_btn : ""}
        iconClassName="text-white hover:underline hover:font-bold cursor-pointer"
        iconSrc={email ? (isEmailVerified ? "/icons/ic-verified.svg" : "") : ""}
        onButtonClick={handleVerifyEmail}
        disabled={isEmailVerified}
        error={emailErrorMessage && localization.getString(emailErrorMessage)}
        onFocus={clearEmailErrorMessageOnFocus}
        onChange={handleEmailChange}
        isRequired={true}
        maxLength={240}
      />

      <OtpModal
        open={showEmailVerificationModal}
        inline={true}
        onSubmit={(otp) => {
          handleVerifyEmailVerificationCode(otp);
        }}
        errorMessage={emailVerificationErrorMessage}
        onResend={() => handleResendEmailVerificationCode()}
        onClose={handleCloseEmailVerificationModal}
      />

      <PhoneNumberInput
        label={localization.mobile}
        placeholder={localization.enter_mobile}
        value={mobile}
        showCountryCode={true}
        onChange={handleMobileChange}
        onFocus={clearMobileErrorMessageOnFocus}
        iconSrc={
          mobile ? (isMobileVerified ? "/icons/ic-verified.svg" : "") : ""
        }
        iconText={!isMobileVerified ? localization.verify_btn : ""}
        iconClassName="text-white hover:underline hover:font-bold cursor-pointer"
        onButtonClick={handleVerifyMobile}
        disabled={isMobileVerified}
        error={mobileErrorMessage && localization.getString(mobileErrorMessage)}
        isRequired={true}
        maxLength={10}
        minLength={10}
      />

      <OtpModal
        open={showMobileVerificationModal}
        inline={true}
        onSubmit={(otp) => {
          handleVerifyMobileVerificationCode(otp);
        }}
        errorMessage={mobileVerificationErrorMessage}
        onResend={() => handleResendMobileVerificationCode()}
        onClose={handleCloseMobileVerificationModal}
      />

      <Button
        type="submit"
        className="mt-4 w-full py-4 rounded-md text-white bg-primary-gradient"
        onClick={handleBackButton}
      >
        <span className="tracking-wider">{localization.back}</span>
      </Button>
    </div>
  );
}
